var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hero-video" }, [
    _c(
      "video",
      {
        staticClass: "video-wrapper",
        attrs: { muted: "", autoplay: "", loop: "" },
        domProps: { muted: true }
      },
      [_c("source", { attrs: { src: _vm.video, type: "video/mp4" } })]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "text-wrapper" }, [
      _c("h1", [_vm._v(_vm._s(_vm.settings.title))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.settings.text))]),
      _vm._v(" "),
      _c("a", { attrs: { href: _vm.settings.button_link } }, [
        _vm._v(_vm._s(_vm.settings.button_label))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }